import { render } from "./ControlloNoteCredito.vue?vue&type=template&id=634ce302"
import script from "./ControlloNoteCredito.vue?vue&type=script&lang=js"
export * from "./ControlloNoteCredito.vue?vue&type=script&lang=js"

import "./ControlloNoteCredito.vue?vue&type=style&index=0&id=634ce302&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__